import { IoCloudyOutline } from "react-icons/io5";
import { WiDayCloudy } from "react-icons/wi";
import { IoRainyOutline } from "react-icons/io5";
import { MdOutlineWbSunny } from "react-icons/md";
import { WiWindy } from "react-icons/wi";
import { BsCloudSnow } from "react-icons/bs";
import { GiFog } from "react-icons/gi";
import { IoCloudyNightOutline } from "react-icons/io5";
import { MdOutlineNightlight } from "react-icons/md";

export const weatherIcons = [
  {
    id: 1,
    name: "cloudy",
    icon: <IoCloudyOutline />,
    image:
      "https://images.unsplash.com/photo-1531171047414-9f2cdc733755?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 2,
    name: "partly-cloudy-day",
    icon: <WiDayCloudy />,
    image:
      "https://images.unsplash.com/photo-1419833173245-f59e1b93f9ee?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 3,
    name: "rain",
    icon: <IoRainyOutline />,
    image:
      "https://images.unsplash.com/photo-1501999635878-71cb5379c2d8?q=80&w=1931&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 4,
    name: "clear-day",
    icon: <MdOutlineWbSunny />,
    image:
      "https://images.unsplash.com/photo-1617141869037-a0db4d26b6af?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 5,
    name: "wind",
    icon: <WiWindy />,
    image:
      "https://images.unsplash.com/photo-1505672678657-cc7037095e60?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 6,
    name: "snow",
    icon: <BsCloudSnow />,
    image:
      "https://images.unsplash.com/photo-1491002052546-bf38f186af56?q=80&w=2108&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 7,
    name: "fog",
    icon: <GiFog />,
    image:
      "https://images.unsplash.com/photo-1486707471592-8e7eb7e36f78?q=80&w=1994&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 8,
    name: "partly-cloudy-night",
    icon: <IoCloudyNightOutline />,
    image:
      "https://images.unsplash.com/photo-1485249245068-d8dc50b77cc7?q=80&w=1931&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 9,
    name: "clear-night",
    icon: <MdOutlineNightlight />,
    image:
      "https://images.unsplash.com/photo-1680542993889-078ce9c8538a?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
];
